import '.eo{font-size:1.125rem;}.ssr-plugin'
import '.e8{line-height:1.75rem;}.ssr-plugin'
import '.hl{text-decoration:none;}.ssr-plugin'
import '.fg{color:var(--primary-red);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="eo e8"
    >
      {translations.privacySubtitle}{' '}
      <a className="hl fg"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="hl fg"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
